/* ============================================================
   Notre Chanson — contact.js
   Client-side validation + AJAX submit of the contact form to
   contact.php. Shows an inline success/error message.
   ============================================================ */
(function () {
  'use strict';

  var form = document.getElementById('contact-form');
  if (!form) return;

  var msg = document.getElementById('contact-msg');
  var btn = document.getElementById('cf-submit');
  var f = {
    name: document.getElementById('cf-name'),
    email: document.getElementById('cf-email'),
    message: document.getElementById('cf-message')
  };

  function show(type, text) {
    msg.hidden = false;
    msg.className = 'nm-form__msg nm-form__msg--' + type;
    msg.textContent = text;
    try { msg.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
  }
  function clearErrors() {
    Object.keys(f).forEach(function (k) { f[k].classList.remove('is-error'); });
  }
  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearErrors();
    msg.hidden = true;

    var bad = [];
    if (!f.name.value.trim()) bad.push('name');
    if (!isEmail(f.email.value.trim())) bad.push('email');
    if (!f.message.value.trim()) bad.push('message');

    if (bad.length) {
      bad.forEach(function (k) { f[k].classList.add('is-error'); });
      show('err', 'Merci de remplir correctement les champs surlignés.');
      f[bad[0]].focus();
      return;
    }

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Envoi en cours…';

    fetch('contact.php', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'fetch' }
    })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (res) {
        if (res && res.ok) {
          form.reset();
          show('ok', 'Merci ! Votre message a bien été envoyé. Nous vous répondons sous 24 h.');
        } else {
          if (res && res.fields) { res.fields.forEach(function (k) { if (f[k]) f[k].classList.add('is-error'); }); }
          show('err', (res && res.error) || "Une erreur est survenue. Écrivez-nous à contact@notrechanson.com.");
        }
      })
      .catch(function () {
        show('err', "Impossible d'envoyer le message pour le moment. Écrivez-nous à contact@notrechanson.com.");
      })
      .then(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });
})();
